import { useState, useEffect } from 'react';

import { useSessionData } from '@confluence/session-data';
import type { ActivityResourceType } from '@confluence/fabric-providers';
import { getActivityProvider } from '@confluence/fabric-providers';

export function useActivityProvider() {
	const [activityProvider, setActivityProvider] = useState<
		Promise<ActivityResourceType> | undefined
	>(undefined);
	const { cloudId } = useSessionData();

	useEffect(() => {
		setActivityProvider(getActivityProvider(cloudId));
	}, [cloudId]);

	return activityProvider;
}
